<template>
    <div class="popup-box">
        <div class="popup-tit">日期选择</div>
        <div class="popup-item">
            <div class="popup-item-tit">选择时间</div>
            <div class="flex flex-y-center flex-start">
                <div v-for="item, index in dateUnitList" :class="`time-item ${checkedDateUnitId === item.id ? 'active' : ''}`" @click="onDateUnitChange(item.id)" :key="index">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="popup-item">
            <div class="popup-item-tit">时间范围</div>
            <div class="flex flex-y-center flex-start">
                <div :class="`time-input ${timeScopeType === TIME_SCOPE.START ? 'active' : ''}`" @click="onTimeScopeTypeChange(TIME_SCOPE.START)">
                    {{ formattedStartTime }}
                </div>
                <div class="line"></div>
                <div :class="`time-input ${timeScopeType === TIME_SCOPE.END ? 'active' : ''}`" @click="onTimeScopeTypeChange(TIME_SCOPE.END)">
                    {{ formattedEndTime }}
                </div>
            </div>
        </div>
        <div class="time-picker-box" v-if="timePickerVisible">
            <van-datetime-picker ref="picker" v-model="timePickerValue" :type="timePickerType" title="选择年月日" :min-date="minDate" :max-date="maxDate" :show-toolbar="false" visible-item-count="2" @change="onTimeValueChange" />
        </div>
        <div class="submit-btn" @click="handleSubmit">确认</div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Field, Picker, Popup } from 'vant';
import { padZero } from '../views/toDo/utils'
Vue.use(Field).use(Picker).use(Popup);

const getLastDate = () => new Date()
const DATE_UNIT_DAY = { id: '1', name: '本日' }
const DATE_UNIT_LIST = [{ id: '2', name: '本月' }, { id: '3', name: '上月' }]
export const ALL_DATE_UNIT = [DATE_UNIT_DAY, ...DATE_UNIT_LIST]

export const getFormatTime = (time, pickerType) => {
    if (!time) return ''
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const day = time.getDate();
    return pickerType == 'day' ? year + '年' + padZero(month, 2) + '月' + padZero(day, 2) + '日' : year + '年' + padZero(month, 2) + '月'
}

const formatTimeTxt = (time, pickerType) => {
    if (!time) return ''
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const day = time.getDate();
    return pickerType == 'day' ? year + '.' + padZero(month, 2) + '.' + padZero(day, 2) : year + '.' + padZero(month, 2)
}

export const getDateText = (dateType, beginMonth, endMonth, pickerType) => {
    if (dateType) {
        const dateUnitItem = ALL_DATE_UNIT.find(item => item.id === dateType)
        return dateUnitItem.name
    }
    return `${formatTimeTxt(beginMonth, pickerType)}-${formatTimeTxt(endMonth, pickerType)}`
}

export const PICKER_TYPE = {
    DAY: 'day',
    MONTH: 'month'
}

export default {
    name: "DatePicker",
    props: {
        value: {
            type: String,
            default: () => '2'
        },
        pickerType: {
            type: String,
            default: () => 'day'
        },
    },
    data() {
        return {
            timePickerVisible: false, // 时间选择器弹窗
            timeScopeType: null,
            minDate: new Date(1949, 0, 1),
            maxDate: getLastDate(),
            timePickerValue: getLastDate(),
            startTime: getLastDate(), // 开始时间
            endTime: getLastDate(), // 结束时间
            checkedDateUnitId: null,//选项id
            TIME_SCOPE: {
                START: 1,
                END: 2
            }
        };
    },
    computed: {
        dateUnitList() {
            return this.pickerType === 'day' ? ALL_DATE_UNIT : DATE_UNIT_LIST
        },
        timePickerType() {
            return this.pickerType == 'day' ? 'date' : 'year-month'
        },
        formattedStartTime() {
            return this.formatTime(this.startTime)
        },
        formattedEndTime() {
            return this.formatTime(this.endTime)
        },
    },
    watch: {
        value: {
            handler(value) {
                if (value && value !== this.checkedDateUnitId) {
                    this.onDateUnitChange(value)
                }
            },
            immediate: true
        },
    },
    mounted() {
        this.startTime = this.timePickerValue
        this.endTime = this.timePickerValue
    },
    methods: {
        // 日期时间--相关
        onDateUnitChange(id) {
            this.timeScopeType = null
            this.checkedDateUnitId = id
            this.timePickerVisible = false
        },
        // 切换输入框
        onTimeScopeTypeChange(type) {
            this.timePickerVisible = false
            this.timeScopeType = type
            this.checkedDateUnitId = null
            // 第二个可选时间范围以第一个已选的时间为最小值
            if (this.timeScopeType == this.TIME_SCOPE.START) {
                this.minDate = new Date(1949, 0, 1)
                this.maxDate = this.endTime
                this.timePickerValue = this.startTime
            } else {
                this.minDate = this.startTime
                this.maxDate = getLastDate()
                this.timePickerValue = this.endTime
            }
            this.$nextTick(() => {
                this.timePickerVisible = true
            })
        },
        // 最终选择的时间
        onTimeValueChange() {
            if (this.timeScopeType === this.TIME_SCOPE.START) {
                this.startTime = this.timePickerValue
            } else if (this.timeScopeType === this.TIME_SCOPE.END) {
                this.endTime = this.timePickerValue
            }
        },
        // 时间格式化
        formatTime(time) {
            return getFormatTime(time, this.pickerType)
        },
        // 确定
        handleSubmit() {
            this.$emit('change', this.checkedDateUnitId)
            this.$emit('submit', this.checkedDateUnitId, this.startTime, this.endTime)
        }
    },
}
</script>

<style scoped lang="less">
.popup-box {
    padding: 50px 30px;
    height: 100%;

    .popup-tit {
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebebeb;
        margin-bottom: 50px;
    }

    .popup-item {
        margin-bottom: 39px;

        .popup-item-tit {
            font-size: 30px;
            font-weight: 400;
            color: #a0acb5;
            margin-bottom: 30px;
        }

        .time-item {
            width: 212px;
            height: 60px;
            border-radius: 4px;
            border: 1px solid #a0acb5;
            font-size: 26px;
            font-weight: 400;
            color: #a0acb5;
            line-height: 60px;
            text-align: center;
            margin-right: 20px;
        }

        .time-item.active,
        .time-input.active {
            background: #2fd0d5;
            border: 1px solid #2fd0d5;
            color: #ffffff;
        }

        .time-input {
            width: 252px;
            height: 60px;
            background: #f1f1f1;
            border-radius: 4px;
            font-size: 26px;
            font-weight: 400;
            color: #a0acb5;
            line-height: 60px;
            text-align: center;
        }

        .line {
            width: 20px;
            height: 2px;
            background: #6c767d;
            margin: 0 40px;
        }
    }

    .time-picker-box {
        margin: 80px 0;
    }

    .submit-btn {
        width: 630px;
        height: 88px;
        background: #333f48;
        border-radius: 44px;
        text-align: center;
        line-height: 88px;
        font-size: 32px;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 1px;
        margin: 0 auto;
        margin-top: 80px;
    }
}
</style>

